const SEO = [
	{
		page: "home",
		description:
			"Meet Juan Nieblas, a passionate software engineer and entrepreneur from Sonora, MX.",
		keywords: ["Juan Nieblas", "Juan Pablo Nieblas Caraveo", "Juan P. Nieblas","jp nieblas","juan pablo nc"],

	},

	{
		page: "about",
		description:
			"I’m Juan Nieblas. I live in Sonora, MX. And I love the technology.",
		keywords: ["Juan Nieblas", "Juan Pablo Nieblas Caraveo", "Juan P. Nieblas","jp nieblas","juan pablo nc"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made.",
		keywords: ["Juan Nieblas", "Juan Pablo Nieblas Caraveo", "Juan P. Nieblas","ratespot","mundo minero","gambit odds","inmobiliaria yuuma","allegro","catoverflow"],
	},

	{
		page: "contact",
		description:
			"I appreciate your interest in reaching out to me.",
		keywords: ["Juan Nieblas", "Juan Pablo Nieblas Caraveo", "Juan P. Nieblas","juan nieblas telefono", "juan nieblas email", "juan nieblas contacto","juan nieblas phone"],
	},
		{
		page: "articles",
		description:
			"I share my passion for redefining what's possible and motivating the innovators of tomorrow.",
		keywords: ["Juan Nieblas", "Juan Pablo Nieblas Caraveo", "Juan P. Nieblas","juan nieblas blog", "juan nieblas articles", "juan nieblas blog articles","juan pablo nieblas blog"],
	},
];

export default SEO;
